import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getOrFail } from 'mythil/object';
import MainApp from './MainApp';
// import GridTest from "../../test/GridTest";
// import Test from "../../test/DomNodeTest";
// import ChildTest from "../../test/ChildTest";
// import TypographyTest from "~/test/TypographyTest";
import { ThemeProvider as NativeBaseProvider } from  "~/native-ui"
import 'react-quill/dist/quill.bubble.css';
import '~/css/quill.css';
import './default.css';
import { GlobalErrorBoundary } from './GlobalErrorBoundary';
import { ThemeStateGetter } from '../../StateGetters/ThemeStateGetter';

const pages = {
    app: (<MainApp />),
    // test: (<Test />),
    // testgrid: (<GridTest />),
    // testchild: (<ChildTest />),
    // testtypography: (<TypographyTest />)
};

export class App extends Component {
    static propTypes = {
        page: PropTypes.string.isRequired,
    };


    render() {
        return (
            <GlobalErrorBoundary>
                <NativeBaseProvider themeColor={ this.props.themeColor }>
                { getOrFail(pages, this.props.page, `Failed to get page ${this.props.page}`, pages) }
                </NativeBaseProvider>
            </GlobalErrorBoundary>
        )
    }
};

const RXApp = connect((state) => ({
    page: state.page,
    themeColor: new ThemeStateGetter(state).getThemeColor(),
}), () => ({

}))(App);

export default RXApp;